import { Button, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from 'react';

const ActionButton = ({ handleClick, disable, label, buttonStyle, fontStyle }) => {
    return (
        <div>
            <Button
                disabled={disable}
                size="small"
                sx={disable?{
                    padding: '3px',
                    marginLeft: '15px',
                    borderRadius: "2px",
                    background: '#3C4B69',
                    borderColor: '#3C4B69',
                    height: "30px",
                  }:{
                    padding: '3px',
                    marginLeft: '15px',
                    borderRadius: "2px",
                    background: '#6378CA',
                    borderColor: '#6378CA',
                    height: "30px",
                    ':hover': {
                      background: '#3D58BD',
                      borderColor: '#3D58BD',
                    }
                  }
                }
                style={buttonStyle}
                variant="outlined"
                onClick={handleClick}
            >
                <Typography
                    sx={disable?{color: "rgba(255, 255, 255, 0.38)",fontFamily: 'Lato', fontWeight: "400", fontSize: "12px", lineHeight: "16px" }:{ color: "#E6E7EB", fontFamily: 'Lato', fontWeight: "400", fontSize: "12px", lineHeight: "16px" }}
                    style={fontStyle}
                >
                    {label}
                </Typography>
            </Button>
        </div>
    )
}
ActionButton.propTypes = {
    handleClick: PropTypes.func,
    disable: PropTypes.bool,
    label: PropTypes.string,
    buttonStyle: PropTypes.any,
    fontStyle: PropTypes.any,

}
export default ActionButton;